import "./table-card.css";
import React from 'react';
  
const TableCard = ({ content }) => { 
       return (
        <div className='table-card'>
            <div className='table-card-content'>
                 {content}
              </div>
        </div>

       );
};

export default TableCard; 